import React from 'react';
import AnnouncementSection from '../components/AnnouncementSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_3695.JPG";
import SeoContentSection from "../components/SeoContentSection";

const Competition = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="NIECCE Teacher Training Course"
  subtitle="Participate in challenges and showcase your early education skills"
 />
 <AnnouncementSection />
 <SeoContentSection title="Teacher Training Course Competitions">
   <p>
     NIECCE competitions give teacher training students an opportunity to practise creativity, communication, storytelling, and classroom presentation. These activities help future educators turn course learning into confident teaching skills.
   </p>
   <p>
     Students from our nursery teacher training and Montessori programs can participate, learn from peers, and celebrate achievement. Competitions are designed to encourage collaboration while keeping the focus on joyful, practical early childhood education.
   </p>
 </SeoContentSection>
    </>
  );
};

export default Competition;
